import { Tag, Col, Panel, Table, Whisper, IconButton, Popover, Dropdown } from "rsuite"
import MoreIcon from '@rsuite/icons/legacy/More';

const { Cell } = Table;

export default function ValidatedValueCell ({ rowData, dataKey, ...props }) {
    return (
        <Cell {...props} className="tag-cell" verticalAlign="middle">
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}} >
                <Whisper placement="autoVerticalEnd" trigger="hover" speaker={
                    <Popover>
                        <h5>Норма выбросов</h5>
                        <span>Норма выбросов в <span style={{fontWeight: "bold", color: rowData.validated ? "green" : "red"}}>140000</span> {rowData.validated ? "не" : ""} превышена</span>
                    </Popover>
                }>
                    <Tag color={rowData.validated ? "green" : "red"}>{rowData[dataKey]}</Tag>
                </Whisper>
            </div>
        </Cell>
    );
};